// Copyright (c) 2026 Yunus YILDIZ — SPDX-License-Identifier: BUSL-1.1

import { apiClient } from './client'
import type { ApiKey } from '@/types'

export interface CreateApiKeyPayload {
  name: string
  scopes: string[]
  expiresAt?: string
}

export interface CreateApiKeyResponse {
  apiKey: ApiKey
  secret: string // Only shown once
}

export const apiKeysApi = {
  list: () => apiClient.get<ApiKey[]>('/v1/api-keys'),

  getById: (id: string) => apiClient.get<ApiKey>(`/v1/api-keys/${id}`),

  create: (payload: CreateApiKeyPayload) =>
    apiClient.post<CreateApiKeyResponse>('/v1/api-keys', payload),

  revoke: (id: string) => apiClient.delete(`/v1/api-keys/${id}`),

  rotate: (id: string) =>
    apiClient.post<CreateApiKeyResponse>(`/v1/api-keys/${id}/rotate`),
}
